// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.view-messages--overlay[data-v-2544486c] {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	z-index: 1050;
	pointer-events: none;
}
.view-messages--overlay .alert[data-v-2544486c] {
	pointer-events: auto;
	margin: 0.5rem;
}
.list-enter-active[data-v-2544486c], .list-leave-active[data-v-2544486c] {
	transition: all 0.3s;
}
.list-enter[data-v-2544486c], .list-leave-to[data-v-2544486c] /* .list-leave-active below version 2.1.8 */ {
	opacity: 0;
	transform: translateY(-10px);
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
